export default __webpack_public_path__ + "static/media/water.68f00eb8.svg";